// extracted by mini-css-extract-plugin
export default {"containerRating":"Rating_containerRating__wvS9D","spanRating":"Rating_spanRating__ceHK8","rating":"Rating_rating__-RhId"};